export const ExtraSpace = 64